import { Card, Col, Container, Row } from "react-bootstrap";
import DataSharev2 from "./Common/DataSharev2";
import { useTranslation } from "react-i18next";

export default function OnCitaNoComienzaDiferentDayV2({cita}){
    const { t } = useTranslation();
    return (
        <Container>
            <Row>
                <Col xs="12" md={{span: 10, offset: 1}}>
                    <Card className='mt-2 mb-5 shadow-sm'>
                        <Card.Body className="p-5">
                            <DataSharev2 cita={cita} title={t('cita_comienza')} />                       
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>        
    )
}